<template>
  <div
    v-click-outside="closeFilter"
    v-if="$props.visible"
    class="lessons-filter"
  >
    <div class="row">
      <CoursesDropdown
        class="half-third"
        label="Курс"
        @setItem="val => setItem({'courses': val})"
      />
      <BaseSwitch
        class="switch"
        :checked="!$filterParams.in_course"
        @change="val => setItem({'in_course': !val})"
      >
        <p>Урок не привязан к курсу</p>
      </BaseSwitch>
      <SubjectsDropdown
        class="half-third"
        label="Предмет"
        @setItem="val => setItem({'subject': val})"
      />
    </div>
    <div class="row">
      <ThemesAssigmentDropdown
        class="half-second"
        label="Тема"
        is-preload
        @setItem="val => setItem({'theme': val})"
      />
      <div class="labels-input-relative-align">
        <div class="buttons">
          <div class="btn">
            <BaseButton
              small
              @click="applyFilters"
            >
              Применить
            </BaseButton>
          </div>
          <div class="btn">
            <BaseButton
              class="borderless"
              small
              border-without-bg
              @click="resetFilters"
            >
              Сбросить фильтры
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
    <Icon
      type="close"
      class="close-icon"
      size="10"
      @click="toggleVisibility(false)"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import Icon from '@/ui/icon/Icon.vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import BaseSwitch from '@/ui/switch/BaseSwitch.vue'
import CoursesDropdown from '@/pages/learning/learning-lessons/list/parts/CoursesDropdown.vue'
import ThemesAssigmentDropdown from '@/pages/common/dropdowns/themes-assigment-tree/ThemesAssigmentDropdown.vue'
import SubjectsDropdown from '@/pages/common/dropdowns/subject/SubjectsDropdown.vue'
import ClickOutside from '@/features/directives/click-outside.ts'
import {
  lessonsFilters,
  toggleVisibility,
} from '@/pages/learning/learning-lessons/list/model/learn-lessons-filters.model'

Vue.directive('click-outside', ClickOutside)

export default Vue.extend({
  name: 'ToolTipFilter',
  components: {
    Icon,
    SubjectsDropdown,
    ThemesAssigmentDropdown,
    BaseButton,
    CoursesDropdown,
    BaseSwitch,
  },
  effector: {
    $filterParams: lessonsFilters.store.$filterParams,
  },
  props: {
    visible: { type: Boolean, required: true, default: false },
  },
  methods: {
    toggleVisibility,
    closeFilter(event) {
      // check for general filter icon
      if (!event.target.closest('#filter-icon')) {
        toggleVisibility(false)
      }
    },
    setItem(filter) {
      this.$emit('changeFilter', filter)
    },
    applyFilters() {
      this.$emit('setFilter')
      toggleVisibility(false)
    },
    resetFilters() {
      this.$emit('resetFilter') // general filter
    },
  },
})
</script>

<style scoped>
.lessons-filter {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  padding: 30px 20px;
  background-color: #fff;
  z-index: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  .row {
    &:not(:first-child) {
      margin-top: 20px;
    }
  }
  .close-icon {
    position: absolute;
    top: 21px;
    right: 21px;
  }
}

.row {
  display: flex;
  justify-content: space-between;

  .switch {
    display: flex;
    align-items: flex-end;
    margin-bottom: 10px;
  }
}

.half-second {
  width: 100%;
  margin-right: 30px;
}

.half-third {
  width: calc(100% / 3 - 20px);
  flex-shrink: 0;
}

.labels-input-relative-align {
  width: 100%;
  display: flex;
  align-self: flex-end;
  height: 46px;

  .switch {
    display: flex;
    align-items: center;
  }
  .buttons {
    display: flex;
    align-items: center;
    margin-left: auto;

    .btn:first-child {
      margin-right: 38px;
    }
  }
}

.btn {
  width: max-content;
}

.borderless {
  border-color: transparent !important;
  @mixin underline-text;
}

.close-icon {
  cursor: pointer;
  fill: var(--c-grey-3);
}

.arrow-up {
  @mixin arrow-up;
}
.block {
  display: flex;
}
</style>
